import { Box } from '@mui/material';
import { WalletAddress } from '../wallet-address';
import { AvatarSt, AvatarWrapper, ContainerSt, LocationSt, TitleSt } from './account-info.styled';

export const AccountInfo = ({
  accountName,
  image,
  walletAddress,
  showWalletAddress,
  country,
  region,
  avatarSize = 88
}) => {
  return (
    <ContainerSt id="index__components-account-info__containerst__l13">
      <AvatarWrapper id="index__components-account-info__avatarwrapper__l14">
        <AvatarSt id="index__components-account-info__avatarst__l15" src={image} alt={accountName} size={avatarSize} />
        <div id="index__components-account-info__div__l16">
          <TitleSt id="index__components-account-info__titlest__l17" variant="h2">{accountName}</TitleSt>
          {country &&
          <LocationSt id="index__components-account-info__locationst__l19" variant="body2">{`${country}${region ? ', ' + region : ''}`}</LocationSt>
          }
          {showWalletAddress &&
          <Box id="index__components-account-info__wallet-wrapper" sx={{ mb: '4px' }}>
              <WalletAddress address={walletAddress} />
            </Box>
          }
        </div>
      </AvatarWrapper>
    </ContainerSt>);

};